import { Category, GenericObject, LocalizedString, ScalePrice, copyFields, fixDates } from '@synergy/models';

import { Supplier } from './supplier';

export class Product {
    public id!: number;
    public name!: LocalizedString;
    public orderUnitId?: number;
    public orderUnitName?: LocalizedString;
    public number?: string;
    public isActive!: boolean;
    public isNorm!: boolean;
    public isBestPrice!: boolean;
    public tax!: { [index: string]: number };
    public globalTradeItemNumber?: string;
    public bestPrice?: number;
    public createdAt?: Date;
    public updatedAt?: Date;

    public supplier!: Supplier;

    public categories?: Category[];
    public mainPrice!: { [index: string]: number };
    public currentSpecialPrice!: { [index: string]: number };
    public prices!: ScalePrice[];

    public shortDescription?: LocalizedString;
    public longDescription?: LocalizedString;

    public static fromPlainObject(object: GenericObject): Product {
        const product = new Product();

        copyFields(object, product);

        if (object['supplierAccount']) {
            product.supplier = Supplier.fromPlainObject(object['supplierAccount']);
        }

        if (object['categories']) {
            product.categories = object['categories'].map(Category.fromPlainObject);
        }

        fixDates(product, ['createdAt', 'updatedAt']);

        return product;
    }
}
